// actionMap object is based on calendar type, which is defined in the calendarIconLinks.js file.
import { TransitionViewNames } from '../../animations/actions/transitions';
import {
    animateInSubscriberForm,
    animateOauthLauncherPage,
    animateInInAppGuide,
} from '../../animations/animate';

import {
    iosChromeLaunchOauthPopupNow,
} from '../../../../commons/utils/popup';

const actionMap = {
    google: (env) => {
        if (isIOS(env.appStore.flags) && (
            isFacebook(env.appStore.flags, env.appStore.userAgent) ||
            isInstagram(env.appStore.flags, env.appStore.userAgent) ||
            isLinkedIn(env.appStore.flags, env.appStore.userAgent) || 
            env.appStore.flags.isTwitter)
        ) {
            return animateInInAppGuide(env);
        }

        if (isAndroid(env.appStore.flags, env.appStore.userAgent) && (
            isFacebook(env.appStore.flags, env.appStore.userAgent) ||
            isInstagram(env.appStore.flags, env.appStore.userAgent)
            )
        ) {
            return animateInInAppGuide(env);
        }
        return animateOauthLauncherPage(env);
    },

    android: (env) => {
        if (isAndroid(env.appStore.flags, env.appStore.userAgent) && (
            isFacebook(env.appStore.flags, env.appStore.userAgent) ||
            isInstagram(env.appStore.flags, env.appStore.userAgent)
            )
        ) {
            return animateInInAppGuide(env);
        }

        return animateOauthLauncherPage(env);
    },

    // Outlook.com (Web)
    windowslive: (env) => {
        if (isIOS(env.appStore.flags) && (
            isFacebook(env.appStore.flags, env.appStore.userAgent) ||
            isInstagram(env.appStore.flags, env.appStore.userAgent)
            )
        ) {
            return animateInInAppGuide(env);
        }

        return animateOauthLauncherPage(env);
    },

    office365: (env) => {
        if (isIOS(env.appStore.flags) && (
            isFacebook(env.appStore.flags, env.appStore.userAgent) ||
            isInstagram(env.appStore.flags, env.appStore.userAgent)
            )
        ) {
            return animateInInAppGuide(env);
        }

        return animateOauthLauncherPage(env);
    },

    apple: (env) => {
        animateInSubscriberForm(env);
    },

    // Classic Outlook (Desktop)
    outlook: (env) => {
        animateInSubscriberForm(env);
    },

    // New Outlook (Desktop)
    'outlook-new': (env) => {
        animateInSubscriberForm(env);
    },

    ics_other: (env) => {
        animateInSubscriberForm(env);
    },
};

function isIOS (flags) {
    if (flags.mobile && flags.ios) {
        return true;
    }

    return false;
};

function isAndroid (flags, userAgent) {
    if (flags.mobile && flags.android) {
        return true;
    }

    return false;
};

function isLinkedIn (flags, userAgent) {
    if (flags.mobile && 
        (flags.isLinkedIn ||
          userAgent.browser.name === 'LinkedIn')){
        return true;
    }
    return false;
};

function isFacebook (flags, userAgent) {
    if (flags.mobile && 
        userAgent.browser.name === 'Facebook') {
        return true;
    }

    return false;
};

function isInstagram (flags, userAgent) {
    if (flags.mobile && 
        userAgent.browser.name === 'Instagram') {
        return true;
    }

    return false;
};

const nonOauth = [
    'apple',
    'outlook',
    'outlook-new',
    'ics_other',  
];

export default function checkCalendar (calendar) {
    const astore = this.env.animationsStore;
    astore.setOutgoingView(TransitionViewNames.CALENDARS_VIEW);
    this.selectedCalendar = calendar;
    const action = actionMap[calendar];
    if (!nonOauth.includes(calendar)) {
        iosChromeLaunchOauthPopupNow(this);
    }
    if (typeof action === 'function') {
        action(this.env);
    } else {
        animateOauthLauncherPage(this.env);
    }
}
 
export function getAppName () {
    if (!this.flags) {
        return 'default';
    }
    const f = this.flags;
    const ua = this.userAgent;
    if (f.isTwitter) {
        return 'twitter';
    } else if (isLinkedIn(f, ua)) {
        return 'linkedin';
    } 
    else if (isFacebook(f, ua)) {
        return 'facebook';
    } else if (isInstagram(f, ua)) {
        return 'instagram';
    }
    return 'default';
}
